"use client";

import { useParams, useRouter } from "next/navigation";
import { twMerge } from "tailwind-merge";

import { links } from "@/data/links";
import { ChartSlug } from "@/features/analysis/types/chart";
import { useLang } from "@/hooks/use-lang";

import { ChartCategoryLink } from "../data/chart-category-links";
import { getCategoryBySlug } from "../data/chart-config";

type Props = {
  symbol: string;
  link: ChartCategoryLink;
};

export const ChartCategoryNavItem = ({ symbol, link }: Props) => {
  const { lang } = useLang();
  const router = useRouter();
  const params = useParams();

  const slug = params.slug as ChartSlug;
  const category = getCategoryBySlug(slug);
  const isZh = lang === "zh";
  const isActive = category === link.key;

  return (
    <li>
      <button
        type="button"
        className={twMerge(
          "group flex w-full flex-wrap items-center gap-2 border-l-[5px] border-transparent px-4 py-2 text-sm font-bold duration-300 hover:border-sky-600 hover:bg-sky-700/5 hover:text-sky-700",
          isActive && "border-sky-600 bg-sky-700/5",
          link.disabled && "cursor-not-allowed opacity-50"
        )}
        disabled={link.disabled}
        onClick={() => {
          router.push(
            `/${lang}${links.myAnalysisFinancialMetricsChart({
              symbol,
              slug: link.slug,
            })}`
          );
        }}
      >
        <span
          className={twMerge(
            "text-zinc-800 duration-300 group-hover:text-sky-700",
            isActive && "text-sky-700"
          )}
        >
          {link.title}
        </span>
        {isZh && (
          <span
            className={twMerge(
              "text-zinc-500 duration-300 group-hover:text-sky-700",
              isActive && "text-sky-700"
            )}
          >
            {link.subtitle}
          </span>
        )}
      </button>
    </li>
  );
};
